import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import InvoiceIndiaPrintView, {
  INDIA_PRINT_PAGE_STYLE,
  suppressIndiaPrintChrome,
} from "../InvoiceIndia/InvoiceIndiaPrintView";

const PdfFileNewFormet = () => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: " ",
    pageStyle: INDIA_PRINT_PAGE_STYLE,
    onBeforePrint: suppressIndiaPrintChrome,
  });
  const location = useLocation();
  let dataObject = {};
  try {
    const searchParams = new URLSearchParams(location.search);
    const data = searchParams.get("data");
    if (data) {
      dataObject = JSON.parse(data);
    }
  } catch (error) {
    console.log(error);
  }

  return (
    <>
      <div
        style={{
          padding: 10,
          marginBottom: 35,
        }}
      >
        <Button floated="right" onClick={handlePrint}>
          print
        </Button>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <InvoiceIndiaPrintView ref={componentRef} dataObject={dataObject} />
      </div>
    </>
  );
};

export default PdfFileNewFormet;
